import angular from 'angular';
import { filter } from 'lodash';

module.exports = angular.module('common.filters.min-selected', [])
.filter('minSelected', function() {
  return function(value, min) {
    return filter(value, function(v) { return v; }).length < min;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/min-selected.js
 **/